import React, { useState, useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

import img1 from "../../assets/images/DSC03282.jpg";
import img2 from "../../assets/images/DSC03290.jpg";
import img3 from "../../assets/images/DSC03292.jpg";
import img4 from "../../assets/images/DSC03299.jpg";

const images = [img1, img2, img3, img4];

const HeroCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-[90vh] overflow-hidden">
      {/* Carousel */}
      <div
        className="absolute top-0 left-0 flex h-full transition-transform duration-1000 ease-in-out"
        style={{
          transform: `translateX(-${currentIndex * 100}vw)`,
          width: `${images.length * 100}vw`,
        }}
      >
        {images.map((img, index) => (
          <div key={index} className="w-screen h-full flex-shrink-0">
            <img
              src={img}
              alt={`Slide ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40 z-10" />

      {/* Hero Text */}
      <div className="relative z-20 mx-auto px-16 h-full flex items-center">
        <div className="max-w-2xl text-left ml-4 md:ml-12 text-white">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
            USTAZ KIDS — ҮЙРЕТУ ОҢАЙ, ДАМЫТУ ҚУАНЫШТЫ!
          </h1>
          <p className="text-lg md:text-xl mb-8">
            Бұл – әр тәрбиеші мен әдіскердің сенімді серігі. Барлық қажетті
            құрал – бір жерде. Бала үшін мағыналы, тәрбиеші үшін тиімді!
          </p>
          <p className="text-md md:text-lg mb-12">
            Ustaz Kids — балабақшаларға арналған кешенді цифрлық орта. Бұл –
            тәрбиешілер мен әдіскерлердің күнделікті жұмысын жеңілдетіп, сапалы
            тәрбие мен білім беруге бағытталған арнайы құралдар мен ресурстар
            жиынтығы.
          </p>
        </div>
      </div>

      {/* Arrows */}
      <div className="absolute bottom-20 right-40 z-30 flex space-x-3">
        <button
          onClick={prevImage}
          className="hover:text-gray-300 p-2 rounded-full transition"
        >
          <ChevronLeftIcon className="h-5 w-5 text-white" />
        </button>
        <button
          onClick={nextImage}
          className="hover:text-gray-300 p-2 rounded-full transition"
        >
          <ChevronRightIcon className="h-5 w-5 text-white" />
        </button>
      </div>
    </section>
  );
};
export default HeroCarousel;
